const MoveArrow = (props) => (
  <svg
    width={33}
    height={33}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>icon_arrows</title>
    <defs>
      <path
        d="m22.013 26.61-4.95 4.95a1.5 1.5 0 0 1-2.121 0l-4.95-4.95c-.945-.944-.276-2.56 1.06-2.56h3.198v-6.3h-6.3v3.198c0 1.336-1.616 2.005-2.56 1.06l-4.95-4.95a1.5 1.5 0 0 1 0-2.12l4.95-4.95c.944-.945 2.56-.276 2.56 1.06v3.202h6.3v-6.3h-3.202c-1.336 0-2.005-1.616-1.06-2.56l4.95-4.95a1.5 1.5 0 0 1 2.12 0l4.95 4.95c.945.944.276 2.56-1.06 2.56H17.75v6.3h6.3v-3.198c0-1.336 1.616-2.005 2.56-1.06l4.95 4.95a1.5 1.5 0 0 1 0 2.12l-4.95 4.95c-.944.945-2.56.276-2.56-1.06V17.75h-6.3v6.3h3.202c1.336 0 2.005 1.616 1.06 2.56Z"
        id="a"
      />
    </defs>
    <use
      fill="#05FC7B"
      xlinkHref="#a"
      transform="translate(.058 .039)"
      fillRule="evenodd"
    />
  </svg>
);

export default MoveArrow;
